module.exports = __webpack_public_path__ + "static/Info-0a307b43b96429f6e8ec768362e36f86.jpg";